import CloudDownload from "@/assets/icons/cloud-download.svg";
import { useI18n } from "@/contexts/i18nContext";
import { ROUTES } from "@/routes_new";
import { cx } from "@/utils";
import Button from "@components/Button";
import {
  Dropdown,
  DropdownHeading,
  DropdownItem,
  DropdownMenu,
  DropdownSeparator,
  DropdownToggle,
} from "@components/Dropdown";

import styles from "./PublicReportMenu.module.css";

const LANGUAGE_OPTIONS = [
  { value: "en", label: "English" },
  { value: "sv", label: "Svenska" },
];

const CURRENCY_OPTIONS = [
  { value: "SEK", label: "SEK" },
  { value: "USD", label: "USD" },
  { value: "EUR", label: "EUR" },
  { value: "NOK", label: "NOK" },
];

const PublicReportMenu = (props) => {
  const urlParams = new URLSearchParams(window.location.search);

  const { currency: currentCurrency, language: currentLanguage } = useI18n();

  const navTitle = currentLanguage + " / " + currentCurrency;

  const setLanguageTo = (locale) => {
    urlParams.set("locale", locale);
    const url = urlParams.toString();
    location.href = location.pathname + "?" + url;
  };

  const setCurrencyTo = (currency) => {
    urlParams.set("currency", currency);
    const url = urlParams.toString();
    location.href = location.pathname + "?" + url;
  };

  return (
    <>
      <Dropdown>
        <DropdownToggle asChild>
          <button
            className={cx(styles.language, styles.hideInPrint)}
            data-testid="language-currency-toggler"
          >
            {navTitle}
          </button>
        </DropdownToggle>
        <DropdownMenu>
          <DropdownHeading>{L.REPORTS_HEADER_NAV_LANGUAGE}</DropdownHeading>
          {LANGUAGE_OPTIONS.map((option) => (
            <DropdownItem
              key={option.value}
              onClick={() => setLanguageTo(option.value)}
            >
              {option.label}
            </DropdownItem>
          ))}

          <DropdownSeparator />

          <DropdownHeading>{L.REPORTS_HEADER_NAV_CURRENCY}</DropdownHeading>

          {CURRENCY_OPTIONS.map((option) => (
            <DropdownItem
              key={option.value}
              onClick={() => setCurrencyTo(option.value)}
              data-testid={`currency-toggler-${option.value}`}
            >
              {option.label}
            </DropdownItem>
          ))}
        </DropdownMenu>
      </Dropdown>

      {props.pdfUrl ? (
        <Button
          className={cx(styles.desktopOnly, styles.hideInPrint)}
          icon={CloudDownload}
          href={`${props.pdfUrl}?locale=${currentLanguage}`}
        >
          {L.REPORTS_DOWNLOAD_PDF}
        </Button>
      ) : null}
      <Button className={styles.hideInPrint} href={ROUTES.APP_HOME}>
        {L.LOGIN_CTA}
      </Button>
    </>
  );
};

export { PublicReportMenu };
